/* eslint-disable import/prefer-default-export */

import {
  DATA_TABLE_EL_CHANGED,
  FILTERS_CHANGED
} from '../constants/payoutManagerConstants';

const axios = require('axios').default;

import $ from 'jquery';
require('datatables.net-bs4');

export const dataTableElChanged = (el) => ({
  type: DATA_TABLE_EL_CHANGED,
  el
});

export const filtersChanged = (filters) => ({
  type: FILTERS_CHANGED,
  filters
});
